// @ts-nocheck

/**
 *
 * Button
 *
 */

import React from 'react';

import { BaseButton, PrimaryButton, SecondaryButton, TertiaryButton, LinkButton } from './index';
import { Props as BaseButtonProps } from './BaseButton';

export interface Props extends BaseButtonProps {
  variation?: 'primary' | 'secondary' | 'tertiary' | 'link';
}

const Button: React.FC<Props> = ({ variation, ...extraProps }) => {
  switch (variation) {
    case 'primary':
      return <PrimaryButton {...extraProps} />;
    case 'secondary':
      return <SecondaryButton {...extraProps} />;
    case 'tertiary':
      return <TertiaryButton {...extraProps} />;
    case 'link':
      return <LinkButton {...extraProps} />;
    default:
      return <BaseButton {...extraProps} />;
  }
};

Button.displayName = 'Button';

export default Button;
